const styledBy = (property, mapping) => (props) => mapping[props[property]]

export const dateInputStyles = {
  root: {
    width: '100%',
  },
  title: {
    marginBottom: 5,
    fontFamily: 'FSEmeric-Medium',
    '&+*': { marginTop: 0, width: '100%' },
  },
  input: {
    height: styledBy('multiline', {
      undefined: '48px',
      false: '48px',
      true: 'auto',
    }),
  },
}
